export default "__VITE_ASSET__C$jbZ_Mo__"